
import { AttributesMixin, define, Model, type } from "@type-r/models";
import { FilterModel } from "./base-filter-model";
import * as React from 'react';
import { FormSelect, Option } from "lqx-react/lib";


export interface DropdownOptions extends AttributesMixin<typeof DropdownOptions>{}
@define
export class DropdownOptions extends Model {

    static attributes = {
        value: Number,
        label: String
    };
}

export interface DropdownFilter extends AttributesMixin<typeof DropdownFilter>{}
@define
export class DropdownFilter extends FilterModel {
    static attributes = {
        ...FilterModel.attributes,
        selected : type(Number),
        options : [DropdownOptions]
    };

    delete() { 
        this.selected = undefined;
    }

    asLabel() {
        return this.options[this.selected];
    }
}
export const EnterDropdown = ({ onEnter, filterValue }: {onEnter: any, filterValue: DropdownFilter}) => {
    
    filterValue.onChanges((x) => {
        onEnter(x)
    });

    return <FormSelect $value={filterValue.$.selected} >
            {filterValue.options.map((option => <Option key={option.value} value={option.value}>{option.label}</Option> ))}
        </FormSelect>
    ;
}